import React, {Fragment, useEffect, useState} from 'react';

import {getAlternateProvisionReasons, getSchoolYearData} from './DropdownDataProviders' ;

import { renderDropdown, renderDropdownReadOnly} from "./DropdownFunctions";

import SpinnerDiv from "./SpinnerDiv";
import PropTypes from "prop-types";

const DropdownAlternateProvisionReason = ( props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getAlternateProvisionReasons ().then (response =>
        {
            setData ( { loading: false, items: response }) ;
        })
    }, []);

    const options = {
        isSearchable: true,
        isClearable: props.isClearable === null || props.isClearable === undefined ? true : props.isClearable,
    }

    return data.loading === true ? <SpinnerDiv/> :
       (
          props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data, options)
       )
}

export default DropdownAlternateProvisionReason;

DropdownAlternateProvisionReason.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownAlternateProvisionReason.propTypes = {
    onChange: PropTypes.func.isRequired
};